import React from 'react';

import ListItem from './ListItem.jsx';

// props :
// letter (single character)
// items - an array of superclasses, with id, title, and qualifications (ie subjects)
// sibling component expecting #{letter} to act as anchor target
const LetterDetails = React.createClass({

    scroll: function(target, event){

        event.preventDefault();

        var targetElement = document.getElementById(target);
        var targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - 64;
        scrollTo( document.body , targetOffset , 600);

    },

    render: function(){

        var component = this;

        const items = this.props.items.map( ( item ) => {

            return (
                <ListItem
                    id = { item.id }
                    title = { item.title }
                    subjects = { item.qualifications }
                    filteredText = { component.props.filteredText }
                    superclasses = { component.props.superclasses }
                    count = { component.props.count }
                />
            );

        });

        return (
            <div className="letter--detail">
                <h2 id={this.props.letter} className="letter--detail--title">
                    { this.props.letter }
                </h2>
                <ul className="letter--detail--items list__presentational">
                    { items }
                </ul>
                <a href="#subject--search" className="letter--detail--back" onClick={ (event) => this.scroll( 'subject--search', event ) }>
                    Back to top
                </a>
            </div>
        );



    }

});

export default LetterDetails;


/** WEBPACK FOOTER **
 ** ./app/LetterDetails.jsx
 **/